var React = require('react');

function Angular (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.sta0{fill:#DD0031;}\n\t.sta1{fill:#C3002F;}\n\t.sta2{fill:#FFFFFF;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"className":"sta0","points":"125,30 125,30 125,30 31.9,63.2 46.1,186.3 125,230 125,230 125,230 203.9,186.3 218.1,63.2  ","key":0}),React.createElement("polygon",{"className":"sta1","points":"125,30 125,52.2 125,52.1 125,153.4 125,153.4 125,230 125,230 203.9,186.3 218.1,63.2 125,30  ","key":1}),React.createElement("path",{"className":"sta2","d":"M125,52.1L66.8,182.6h0h21.7h0l11.7-29.2h49.4l11.7,29.2h0h21.7h0L125,52.1L125,52.1L125,52.1L125,52.1   L125,52.1z M142,135.4H108l17-40.9L142,135.4z","key":2})])]);
}

Angular.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 250 250","style":{"enableBackground":"new 0 0 250 250"},"xmlSpace":"preserve"};

module.exports = Angular;

Angular.default = Angular;
